import { DownloadPassIcon, InawoPassIcon } from "@src/components/Icon/Icons";
import React, { Fragment } from "react";
import { toast } from "react-hot-toast";
import { toPng } from "html-to-image";
import CustomQrCode from "@src/components/QrCode";
import WhatsAppBrowserBlocker from "@src/components/WhatsappBrowserBlocker";
import useStore from "@src/store";
import { QRCodeCanvas } from "qrcode.react";

const Index = ({
  passImage,
  eventSlug,
  setOpen,
  qr_code,
  admits,
}: {
  passImage: string;
  eventSlug: string;
  setOpen: (value: boolean) => void;
  qr_code: string;
  admits: number;
}) => {
  const isPreviewMode = useStore((state) => state.isPreviewMode);
  const cardRef = React.useRef<HTMLDivElement>(null);
  // const imgRef = React.useRef<HTMLImageElement>(null);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [imageError, setImageError] = React.useState(false);

  const [showWhatsAppBlocker, setShowWhatsAppBlocker] = React.useState(false);

  const isWhatsAppInAppBrowser = () =>
    /(WhatsApp|WA4A|WA4I)/i.test(window.navigator.userAgent);

  //Function to download pass image
  const handleDownload = async () => {
    if (isWhatsAppInAppBrowser()) {
      setShowWhatsAppBlocker(true);
      return;
    }

    if (!cardRef.current || isDownloading) return;
    setIsDownloading(true);
    try {
      const dataUrl = await toPng(cardRef.current, {
        cacheBust: true,
        backgroundColor: "#ffffff",
        pixelRatio:
          typeof window !== "undefined" && window.devicePixelRatio
            ? Math.min(3, window.devicePixelRatio)
            : 2,
        filter: (node) => {
          // If it's an img element and it hasn't loaded or has errored, skip it
          if (node.tagName === "IMG" && (imageError || !imageLoaded)) {
            return false;
          }
          return true;
        },
      });
      const safeSlug = (eventSlug || "pass").replace(/[^a-z0-9-_]/gi, "_");
      const link = document.createElement("a");
      link.download = `${safeSlug}-pass.png`;
      link.href = dataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Pass image downloaded successfully");
    } catch (err) {
      console.error("Error downloading image:", err);
      toast.error(
        "Unable to download the image. Try right-clicking the card and selecting 'Save image as'."
      );
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Fragment>
      {isPreviewMode ? (
        <div className="flex flex-col items-center justify-center w-full xs:h-[500px] xs:w-[510px] bg-white p-10 rounded-[30px]">
          <div className="flex flex-col gap-[12px] items-center mb-4">
            <h3 className="font-medium text-[26px]">Your pass</h3>
            <p className="text-[#71717A] text-[14px] text-center">
              You're in preview mode. The pass below is only for demonstration
              purposes and won't grant you access to the event.
            </p>
          </div>

          <p className="text-sm text-center text-[#71717A]"></p>

          <div
            className="flex h-[400px] w-[280px] flex-col items-center justify-between rounded-[21px] border border-[#D9D9D9] px-[25px] py-[9px]"
            style={{
              backgroundImage: `url(${passImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <p className="my-[11px] text-[11px] font-medium text-white">
              #{eventSlug}
            </p>
            <div
              className="mx-auto flex h-[245px] w-[80%] flex-col items-center justify-between rounded-[22px] bg-[#FFFFFFCC] px-[10px] py-[10px]"
              style={{ backdropFilter: "blur(3px)" }}
            >
              <div>
                <p className="mb-[2px] text-[9px] text-[#4D4D4DE8]">
                  Guest code
                </p>
                <p className="text-[10px] text-[#4D4D4D4D]">{"TWE2110"}</p>
              </div>
              <div className="h-[105px] w-[105px] rounded-[20px] border border-[#3D516080] bg-gradient-to-b from-[#E6FA5200] to-[#E6FA5233] p-[20px]">
                <QRCodeCanvas value="TWE2110" fgColor="#4F7770" size={65} />
              </div>
              <div className="flex flex-col items-center justify-center">
                <p className="mb-[2px] text-center text-[10px] text-[#4D4D4D99]">
                  This is your pass to the wedding
                </p>
                <InawoPassIcon />
              </div>
            </div>
          </div>
        </div>
      ) : qr_code ? (
        <div className="flex flex-col gap-[40px] items-center w-full xs:w-[510px] mx-auto bg-white py-10 rounded-[30px]">
          <div className="flex flex-col gap-[12px] items-center">
            <h3 className="font-medium text-[26px]">Your pass</h3>
            <p className="text-[#71717A] text-[14px]">Show this at the venue</p>
          </div>
          <div className="flex flex-col gap-[16px] items-center">
            {/* card to be downloaded starts here */}
            <div
              ref={cardRef}
              style={{ border: "0.7px solid #D9D9D9" }}
              className="w-[220px] shadow-lg h-[350px] rounded-[22px] py-[9px] px-[15px] flex flex-col items-center justify-between relative"
            >
              <img
                src={passImage}
                // ref={imgRef}
                alt="pass image"
                crossOrigin="anonymous"
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
                className="absolute inset-0 w-full h-full object-cover rounded-[22px]"
              />
              <p className="my-[11px] text-[11px] font-medium text-white text-red absolute z-10">
                #{eventSlug}
              </p>
              <div
                className="w-[90%] rounded-[22px] bg-[#FFFFFFCC] h-[250px] px-[10px] py-[10px] flex flex-col items-center justify-between absolute bottom-[12px]"
                style={{ backdropFilter: "blur(3px)" }}
              >
                <div className="relative w-full flex flex-col items-center justify-center">
                  <p className="text-[9px] text-[#4D4D4DE8] mb-[2px]">
                    Guest code
                  </p>
                  <p className="text-[10px] text-[#4D4D4D4D]">{qr_code}</p>
                  {/* {admits && admits > 1 && (
                    <p className="absolute flex items-center justify-center text-[14px] text-[#4D4D4DE8] font-medium border border-[#4D4D4DE8] rounded-full w-8 h-8 top-0 right-0">
                      +{admits - 1}
                    </p>
                  )} */}
                </div>
                <div className="w-full flex justify-center items-center">
                  <div className="px-2 py-1 rounded-full border border-gray-500">
                    <p className="text-green-900 font-medium text-xs">
                      Admits: {admits ?? 0 + 1}
                    </p>
                  </div>
                </div>
                <CustomQrCode code={qr_code} />
                <div className="flex flex-col items-center justify-center">
                  <p className="mb-[2px] text-[#4D4D4D99] text-[10px] text-center">
                    This is your pass to the wedding
                  </p>
                  <InawoPassIcon />
                </div>
              </div>
            </div>
            {/* card to be downloaded ends here */}
            {qr_code && (
              <button
                onClick={handleDownload}
                className="flex items-center justify-center gap-[8px] bg-[#FFFBEB] h-[35px] rounded-[7px] py-[7px] w-[188px] mx-auto px-[12px] font-medium shadow-lg"
                style={{ border: "0.579px solid #5C5C5C" }}
                disabled={isDownloading}
                aria-busy={isDownloading}
              >
                <DownloadPassIcon />
                <p className="text-[#141414] text-[12px] font-normal">
                  {isDownloading ? "Downloading..." : "Download your pass"}
                </p>
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center w-full xs:h-[500px] xs:w-[510px] bg-white py-10 rounded-[30px]">
          <p className="text-center">You don't have a pass yet</p>
        </div>
      )}
      <WhatsAppBrowserBlocker
        open={showWhatsAppBlocker}
        onClose={() => setShowWhatsAppBlocker(false)}
      />
    </Fragment>
  );
};

export default Index;
